<section class="statistic_report">
    <ul class="statistic_report_top">
        <li>Report</li>
        <li *ngIf="activeTab !== 'BrowserReport'">
            <div class="dropdown">
                <label for="browsers">Execution Platform</label>
                <select name="browsers" id="browsers" (change)="onChangeBrowser($event)" [(ngModel)]="selectedBrowser">
                    <option *ngFor="let browserKey of objectKeys(report.report_links.live_status)" [value]="browserKey">
                        {{ browserKey }}
                    </option>
                </select>
                <label for="iterations" *ngIf="iterationOptions.length > 1">Iteration</label>
                <select name="iterations" id="iterations" (change)="onChangIteration($event)"
                    [(ngModel)]="selectedIteration" *ngIf="iterationOptions.length > 1">
                    <option *ngFor="let option of iterationOptions" [value]="option">{{ option }}</option>
                </select>
            </div>
        </li>
        <li matTooltip="Resoltuion">🖥️ {{report.resolution}}</li>
        <li (click)="activateTab('Statistic')" [class.active]="activeTab === 'Statistic'">Statistics</li>
        <li (click)="activateTab('Steps')" [class.active]="activeTab === 'Steps'">Steps</li>
        <li (click)="activateTab('BrowserReport')" [class.active]="activeTab === 'BrowserReport'">Platform Report</li>
    </ul>
    <div class="statistic_report_bottom">
        <div *ngIf="activeTab === 'Statistic' && isBrowserIterationDataAvailable" class="bottom_container">
            <div class="statistic_report_bottom_table">
                <div class="table env-table">
                    <div class="report-bar">
                        <div class="info-item">
                            <span class="icon" matTooltip="Project Name">📁</span>
                            <span class="value" matTooltip="{{projectName}}">{{projectName}}</span>
                        </div>
                        <span class="divider"></span>

                        <div class="info-item">
                            <span class="icon" matTooltip="Execution Machine">🖥️</span>
                            <span class="value"
                                [matTooltip]="report.default_hub ? 'Default Lab' : report.local_execution && report.execution_machine === 'Default Machine' ? ((report.port === 0 || report.port === -1) ? report.hub_ip : report.hub_ip + ':' + report.port) : report.local_execution && report.execution_machine !== 'Default Machine' ? report.execution_machine : ''">
                                {{report.default_hub? 'Default Lab': report.local_execution? 'Custom Lab': ''}}
                            </span>
                        </div>
                        <span class="divider"></span>
                        <div class="info-item">
                            <span class="icon" matTooltip="Date and time">📅</span>
                            <span class="value"
                                matTooltip="{{report?.start_time | date:'MMM d, yyyy, h:mm:ss a'}}">{{report?.start_time
                                | date:'MMM d, yyyy, h:mm:ss a'}}</span>
                        </div>
                        <span class="divider"></span>
                        <div class="info-item">
                            <span class="icon" matTooltip="User">👤</span>
                            <span class="value" matTooltip="{{report.created_by}}">{{report.created_by}}</span>
                        </div>
                        <span class="divider"
                            *ngIf="report && (report.default_pause !== undefined && report.default_pause !== null && (+report.default_pause) > 0)"></span>
                        <div class="delay-badge"
                            *ngIf="report && (report.default_pause !== undefined && report.default_pause !== null && (+report.default_pause) > 0)">
                            <span class="icon" matTooltip="Delay">⏱️</span>
                            <span class="value" matTooltip="{{ (report.default_pause/1000) }}">{{
                                (report.default_pause/1000) }} Sec</span>
                        </div>
                        <span class="divider" *ngIf="report?.send_mail"></span>
                        <div class="badge" *ngIf="report?.send_mail"
                            matTooltip="Email notifications were enabled for this test">
                            <span class="badge-icon">✅</span>
                            Email Notification
                        </div>
                        <div class="badge" *ngIf="report?.screenshot_required"
                            matTooltip="Visual comparison feature was enabled">
                            <span class="badge-icon">✅</span>
                            Visual Comparison
                        </div>
                    </div>
                </div>
            </div>
            <div class="heading">
                <h2>Report Statistics</h2>
                <p>The following graphs show passing and failing statistics for suite</p>
            </div>
            <div class="chart">
                <ng-container *ngFor="let chart of doughnutChartData;index as i">
                    <canvas *ngIf="chartGenerated" baseChart [data]="chart" [labels]="doughnutChartLabels"
                        [chartType]="doughnutChartType" [options]="doughnutChartOptions[i]"
                        [colors]="doughnutChartColors" height="200" width="300">
                    </canvas>
                </ng-container>
                <div class="chart-loader" *ngIf="!chartGenerated">
                    <div class="loader chart-loader"></div>
                </div>
            </div>
            <div class="loader-container">
                <div class="loader" *ngIf="statisticTableLoading"></div>
                <table class="statistic-table" *ngIf="!statisticTableLoading">
                    <thead>
                        <tr class="tab_head">
                            <th>Suite</th>
                            <th colspan="3">Features</th>
                            <th colspan="3">Scenarios</th>
                            <th colspan="3">Steps</th>
                            <th>Status</th>
                            <th>Duration</th>
                        </tr>
                        <tr>
                            <th>
                                <div></div>
                            </th>
                            <th class="passed">
                                <div>Passed</div>
                            </th>
                            <th class="failed">
                                <div>Failed</div>
                            </th>
                            <th class="total">
                                <div>Total</div>
                            </th>
                            <th class="passed">
                                <div>Passed</div>
                            </th>
                            <th class="failed">
                                <div>Failed</div>
                            </th>
                            <th class="total">
                                <div>Total</div>
                            </th>
                            <th class="passed">
                                <div>Passed</div>
                            </th>
                            <th class="failed">
                                <div>Failed</div>
                            </th>
                            <th class="total">
                                <div>Total</div>
                            </th>
                            <th>
                                <div></div>
                            </th>
                            <th>
                                <div></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of tableData" [class]="row.class">
                            <td class="ellipsis" matTooltip="{{row.executionModelName}}"><a
                                    (click)="switchToStepsTab(selectedBrowser, selectedIteration)">{{
                                    row.executionModelName }}</a></td>
                            <td [class.passed]="row.Fepassed > 0">{{ row.Fepassed }}</td>
                            <td [class.failed]="row.Fefailed > 0">{{ row.Fefailed }}</td>
                            <td [class.total]="row.Fetotal > 0">{{ row.Fetotal }}</td>
                            <td [class.passed]="row.Scpassed > 0">{{ row.Scpassed }}</td>
                            <td [class.failed]="row.Scfailed > 0">{{ row.Scfailed }}</td>
                            <td [class.total]="row.Sctotal > 0">{{ row.Sctotal }}</td>
                            <td [class.passed]="row.Stpassed > 0">{{ row.Stpassed }}</td>
                            <td [class.failed]="row.Stfailed > 0">{{ row.Stfailed }}</td>
                            <td [class.total]="row.Sttotal > 0">{{ row.Sttotal }}</td>
                            <td [ngClass]="{'passed': row.status === 'PASSED', 'failed': row.status === 'FAILED'}">{{
                                row.status }}</td>
                            <td class="ellipsis" matTooltip="{{ row.duration | duration }}">{{ row.duration | duration
                                }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td>{{ tableFootData.Fepassed != '' ? tableFootData.Fepassed + '%' : '-'}}</td>
                            <td>{{ tableFootData.Fefailed != '' ? tableFootData.Fefailed + '%' : '-'}}</td>
                            <td></td>
                            <td>{{ tableFootData.Scpassed != '' ? tableFootData.Scpassed + '%' : '-'}}</td>
                            <td>{{ tableFootData.Scfailed != '' ? tableFootData.Scfailed + '%' : '-'}}</td>
                            <td></td>
                            <td>{{ tableFootData.Stpassed != '' ? tableFootData.Stpassed + '%' : '-'}}</td>
                            <td>{{ tableFootData.Stfailed != '' ? tableFootData.Stfailed + '%' : '-'}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div *ngIf="activeTab === 'Steps' && isBrowserIterationDataAvailable">
            <div class="loader-container">
                <div class="loader steps-loader" *ngIf="stepsTableLoading"></div>
                <table class="steps-table" *ngIf="!stepsTableLoading">
                    <thead>
                        <tr class="tab_head">
                            <th>Suite</th>
                            <th colspan="4">Steps</th>
                        </tr>
                        <tr>
                            <th>
                                <div></div>
                            </th>
                            <th>
                                <div>Sr.No.</div>
                            </th>
                            <th>
                                <div>Step Name</div>
                            </th>
                            <th>
                                <div>Duration</div>
                            </th>
                            <th>
                                <div>Status</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of stepsTableData" [class]="row.class">
                            <td>{{ row.suiteName }}</td>
                            <td>{{ row.order }}</td>
                            <td><a (click)="switchToStepwise(selectedBrowser, selectedIteration, row.order)">{{
                                    row.stepName }}</a></td>
                            <td class="ellipsis" matTooltip="{{ (row.endTime - row.startTime) | duration }}">{{
                                (row.endTime - row.startTime) | duration }}</td>
                            <td [ngClass]="{'passed': row.status === 'PASSED', 'failed': row.status === 'FAILED'}">
                                {{row.status}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div *ngIf="currentReportLoadFailed" class="current_report_load_failed">
            <img src="../../../assets/images/error-cross.png" alt="Error" class="alert-image">
            <h3>Error in loading report. retry loading again...</h3>
            <mat-icon (click)="checkStepwiseDataAndUpdate()" matTooltip="Retry">refresh</mat-icon>
        </div>

        <div class="loader-container"
            *ngIf="(activeTab === 'Steps' || activeTab === 'Statistic') && !isBrowserIterationDataAvailable && !currentReportLoadFailed">
            <div class="report-loader"></div>
        </div>

        <div *ngIf="activeTab === 'BrowserReport'" class="browser-report-container">
            <table class="browser-report-table">
                <thead>
                    <tr>
                        <th>Execution Platform</th>
                        <th>Iteration</th>
                        <th>Duration</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let browserKey of objectKeys(report?.report_links?.live_status)">
                        <ng-container
                            *ngFor="let iterationKey of objectKeys(report?.report_links?.live_status[browserKey])">
                            <tr
                                [ngClass]="{'skipped': report?.report_links?.live_status[browserKey][iterationKey].status === '', 'passed': report?.report_links?.live_status[browserKey][iterationKey].status === 'PASSED', 'failed': report?.report_links?.live_status[browserKey][iterationKey].status === 'FAILED'}">
                                <td><a (click)="switchToStatisticTab(browserKey, iterationKey)">{{browserKey}}</a></td>
                                <td>{{ iterationKey }}</td>
                                <td class="ellipsis"
                                    *ngIf="report?.report_links?.live_status[browserKey][iterationKey].status === 'PASSED' || report?.report_links?.live_status[browserKey][iterationKey].status === 'FAILED'"
                                    matTooltip="{{(report?.report_links?.live_status[browserKey][iterationKey].endTime - report?.report_links?.live_status[browserKey][iterationKey].startTime | duration)}}">
                                    {{(report?.report_links?.live_status[browserKey][iterationKey].endTime -
                                    report?.report_links?.live_status[browserKey][iterationKey].startTime | duration)}}
                                </td>
                                <td *ngIf="report?.report_links?.live_status[browserKey][iterationKey].status === ''">
                                </td>
                                <td
                                    *ngIf="report?.report_links?.live_status[browserKey][iterationKey].status === 'PASSED' || report?.report_links?.live_status[browserKey][iterationKey].status === 'FAILED'">
                                    {{report?.report_links?.live_status[browserKey][iterationKey].status}}</td>
                                <td *ngIf="report?.report_links?.live_status[browserKey][iterationKey].status === ''">
                                    SKIPPED</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</section>